import React, { useEffect, useState } from "react";
import axios from "axios";
import PostGrid from "./PostGrid";

const Posts = ({ onCount }) => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/posts`);
        setPosts(response?.data || []);
        onCount?.(response?.data?.length || 0);
      } catch (err) {
        console.log(err);
      }
      setIsLoading(false);
    };
    fetchPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PostGrid posts={posts} isLoading={isLoading} />;
};

export default Posts;
